// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1xFis","info":"UpdateTermsInfo_info__3mIKj"};